import React from "react";
import { notification } from 'antd';
import { withRouter } from '../utils/zRouterem';
import { connect } from 'react-redux';
import NProgress from 'nprogress';
import { Helmet } from 'react-helmet-async';
import Loader from "../components/layout/Loader/Loader";
import compose from "../utils/zloz";
import PublicLayout from "./Public";
import AppLayout from "./App";
import AuthLayout from "./Auth";
import {ReducerType} from "../redux/reducer.type";
import { LayoutPropsType, LayoutsPrevPropsType } from "./layout.type";
import { titlePrefix, titleDefult } from "../config/config";
import userActions from "../redux/user/actions";
import { withTranslation } from 'react-i18next';
import { history } from "../config/historia";
import {
    ROUTE_ACTIVE_WORKSPACES_DETAILS,
    ROUTE_DEVICES,
    ROUTE_DEVICES_DETAILS,
    ROUTE_DRIVERS,
    ROUTE_DRIVERS_DETAILS, ROUTE_INVOICE,
    ROUTE_LOGIN,
    ROUTE_POI,
    ROUTE_PROFILE_EDIT,
    ROUTE_SENT,
    ROUTE_ROUTE_REPORT,
    ROUTE_ROUTES,
    ROUTE_STATISTICS,
    ROUTE_TELEMETRY,
    ROUTE_VEHICLES,
    ROUTE_VEHICLES_DETAILS,
    ROUTE_WORKSPACE_BLOCKED,
    ROUTE_WORKSPACES_LIST
} from "../config/routes";
import {isSuperAdmin, validateSessionStorage} from "../utils/utils";

const Layouts = {
    public: PublicLayout,
    auth: AuthLayout,
    app: AppLayout,
};

class Layout extends React.Component<LayoutPropsType, any> {
    previousPath = '';

    /**
     * Sciezki, ktore dzialaja BEZ aktywnego obszaru - dopasowanie po
     * poczatku adresu, zeby objac tez podstrony i parametry.
     *
     *   /workspaces   lista obszarow, tworzenie, konto zablokowane
     *   /workspace/   superadmin ogladajacy konkretnego klienta
     */
    static SCIEZKI_BEZ_OBSZARU = [
        ROUTE_WORKSPACES_LIST,
        '/workspace/',
        ROUTE_PROFILE_EDIT,
        ROUTE_ACTIVE_WORKSPACES_DETAILS,
    ];

    /**
     * Zalogowany, ale bez aktywnego obszaru.
     *
     * Ekrany aplikacji siegaja po `activeWorkspace.uuid` w 57 miejscach
     * BEZ sprawdzenia - i w normalnym przeplywie slusznie, bo saga
     * ustawia `authorized` i `activeWorkspace` JEDNA akcja, atomowo
     * (redux/user/sagas.ts). Gdy uzytkownik jest zalogowany, obszar jest.
     *
     * Zostaje jeden przypadek: konto bez ZADNEGO przypisanego obszaru
     * (`data.workspaces` puste). Do wrzesnia 2026 stal tu PUSTY blok
     * warunkowy - ktos ten przypadek zauwazyl i zostawil bez obslugi.
     * Ekrany renderowaly sie wtedy z pusta wartoscia i wywalaly na
     * pierwszym `activeWorkspace.uuid`; granica bledu pokazywala
     * komunikat zamiast bialej strony, ale ekran nie dzialal.
     *
     * DLACZEGO TUTAJ, A NIE W KAZDYM EKRANIE. Dopisanie `| null` do
     * wszystkich 57 deklaracji daje 92 bledy kompilacji w 46 plikach -
     * czyli 92 miejsca uczace sie radzic ze stanem, ktory nie powinien
     * do nich dotrzec. Automat dopisujacy wszedzie `if (activeWorkspace)`
     * usunalby bledy i zostawil PUSTE EKRANY: ciszej, a wiec gorzej.
     * Pilnujemy wiec w jednym miejscu - dokladnie tak, jak nizej dziala
     * to juz dla superadmina bez wybranego klienta.
     */
    bezAktywnegoObszaru = (): void => {
        const { user, t, location: { pathname } } = this.props;

        // Logowanie jeszcze trwa - obszar dojdzie razem z `authorized`,
        // ta sama akcja. Przekierowanie teraz byloby falszywym alarmem.
        if (!user.authorized) return;
        if (/^\/auth(?=\/|$)/i.test(pathname)) return;

        // Superadmina obsluguje osobny blok nizej: ma wlasna liste ekranow
        // i wlasny komunikat, bo jego brak obszaru znaczy co innego -
        // nie "nie masz obszaru", tylko "nie wybrales klienta".
        if (isSuperAdmin()) return;

        if (Layout.SCIEZKI_BEZ_OBSZARU.some((s: string) => pathname.startsWith(s))) return;

        // `key` sprawia, ze powtorzone wywolania podmieniaja komunikat
        // zamiast ustawiac go w stos.
        notification.info({
            key: "brak-aktywnego-obszaru",
            message: t("no_active_workspace"),
            description: t("no_active_workspace_desc"),
            duration: 8
        });
        history.push(ROUTE_WORKSPACES_LIST);
    };

    componentDidMount(): void {
        const {
            dispatch,
            location: { pathname },
        } = this.props;
        if (sessionStorage.getItem('access_token')) {
            dispatch({
                type: userActions.LOAD_CURRENT_ACCOUNT
            });
        }
        if (pathname === '/' && sessionStorage.getItem('access_token')) {
            history.push(ROUTE_TELEMETRY);
        } else if (pathname === '/' && !sessionStorage.getItem('access_token')) {
            history.push(ROUTE_LOGIN);
        }
    }
    componentDidUpdate(prevProps: Readonly<LayoutsPrevPropsType>, prevState: Readonly<{}>, snapshot?: any): void {
        const { location, user, dispatch, t, location: { pathname } } = this.props;
        // onRefresh
        if(!this.props.user.activeWorkspace) {
            this.bezAktywnegoObszaru();
        } else {
            if (!isSuperAdmin() &&
                !this.props.location.pathname.includes("/auth/") &&
                // (this.props.location.pathname !== ROUTE_ACTIVE_WORKSPACES_DETAILS) &&
                (prevProps.user.activeWorkspace !== this.props.user.activeWorkspace) &&
                this.props.user.activeWorkspace.is_blocked ) {
                if(Number(this.props.user.activeWorkspace.is_blocked) === 1) {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                } else if(Number(this.props.user.activeWorkspace.is_blocked) === 2 && this.props.user.activeWorkspace.customer_type === "S" && (user.uuid === user.activeWorkspace.owner?.uuid)) {
                    if(this.props.location.pathname.includes("/invoices/details/")) {} else {
                        history.push(ROUTE_INVOICE)
                    }
                } else {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                }
            }
            // onChange
            if (!isSuperAdmin() &&
                (prevProps.location.pathname !== this.props.location.pathname) &&
                !this.props.location.pathname.includes("/auth/") &&
                // (this.props.location.pathname !== ROUTE_ACTIVE_WORKSPACES_DETAILS ) &&
                this.props.user.activeWorkspace.is_blocked ) {
                if(Number(this.props.user.activeWorkspace.is_blocked) === 1) {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                } else if(Number(this.props.user.activeWorkspace.is_blocked) === 2 && this.props.user.activeWorkspace.customer_type === "S" && (user.uuid === user.activeWorkspace.owner?.uuid)) {
                    if(this.props.location.pathname.includes("/invoices/details/")) {} else {
                        history.push(ROUTE_INVOICE)
                    }
                } else {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                }
            }
        }


        if(isSuperAdmin() && !validateSessionStorage("superAdminWorkspace")){
            if (pathname === ROUTE_TELEMETRY ||
                pathname === ROUTE_STATISTICS ||
                pathname === ROUTE_ROUTES ||
                pathname === ROUTE_ROUTE_REPORT ||
                pathname === ROUTE_DEVICES ||
                pathname === ROUTE_DEVICES_DETAILS() ||
                pathname === ROUTE_VEHICLES ||
                pathname === ROUTE_VEHICLES_DETAILS() ||
                pathname === ROUTE_DRIVERS ||
                pathname === ROUTE_DRIVERS_DETAILS() ||
                pathname === ROUTE_POI ||
                // Deklaracje SENT dotycza pojazdow konkretnego klienta,
                // a administrator platformy wlasnej floty nie ma.
                pathname === ROUTE_SENT ||
                pathname === ROUTE_ACTIVE_WORKSPACES_DETAILS
                // pathname === ROUTE_COUNTRY_LIST ||
                // pathname === ROUTE_ADDRESS_TYPE_LIST ||
                // pathname === ROUTE_ADDRESS_TYPE_CREATE ||
                // pathname === ROUTE_CONTACT_TYPE_LIST ||
                // pathname === ROUTE_CONSENTS ||
                // pathname === ROUTE_CONSENT_CREATE ||
                // pathname === ROUTE_CONSENT_EDIT()
            ){
                // Te ekrany pokazuja dane konkretnego klienta, a administrator
                // platformy nie ma wlasnej floty. Wczesniej bylo tu samo
                // przekierowanie - bez komunikatu, bez zadania w Network -
                // co wygladalo jak awaria dziewieciu ekranow (znalezisko B6).
                // `key` sprawia, ze powtorzone wywolania podmieniaja komunikat
                // zamiast ustawiac go w stos.
                notification.info({
                    key: "wymagany-wybor-klienta",
                    message: t("select_client_required"),
                    description: t("select_client_required_desc"),
                    duration: 8
                });
                history.push(ROUTE_WORKSPACES_LIST)
            }
        }

        const { prevLocation } = prevProps;
        if (location !== prevLocation) {
            window.scrollTo(0, 0)
        }
        if (!user.authorized && !user.loading && !(/^\/auth(?=\/|$)/i.test(pathname))) {
            if (sessionStorage.getItem("access_token") || localStorage.getItem("access_token")) {
                return;
            } else {
                console.log("src/layouts/index - LOGOUT - CHECK - POSSIBLY ISSUES");
                dispatch({
                    type: userActions.LOGOUT,
                    payload: this.props.location.pathname
                });
            }
        }
    }

    render(): React.ReactNode {
        const {
            children,
            location: { pathname, search },
            user,
            t,
        } = this.props;

        // NProgress Management
        const currentPath = pathname + search;
        if (currentPath !== this.previousPath) {
            NProgress.start()
        }

        setTimeout(() => {
            NProgress.done();
            this.previousPath = currentPath;
        }, 300);

        // Layout Rendering
        const getLayout = () => {
            if (pathname === '/') {
                return 'public'
            }
            if (/^\/auth(?=\/|$)/i.test(pathname)) {
                return 'auth'
            }
            return 'app'
        };

        const Container: any = Layouts[getLayout()];
        const isUserAuthorized = user.authorized;
        const isUserLoading = user.loading;
        const isAuthLayout = getLayout() === 'auth';

        const BootstrappedLayout = () => {
            // show loader when user in check authorization process, not authorized yet and not on login pages
            if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
                return <Loader spinning={true} fullScreen={true} />
            }
            // in other case render previously set layout
            return <Container>{children}</Container>
        };

        return (
            <>
                <Helmet titleTemplate={`${t(titlePrefix)} | %s`} title={t(titleDefult)} />
                {BootstrappedLayout()}
            </>
        );
    }
}

const mapStateToProps = (state: ReducerType) => {
    // console.log({config: state.customerConfiguration, activeWorkspace: state.user.activeWorkspace && state.user.activeWorkspace.uuid})
    return ({ user: state.user })
};

export default withRouter(compose<LayoutPropsType, any>(
    connect(mapStateToProps),
    withTranslation('template')
)(Layout)) as React.FC<{ children?: React.ReactNode }>;
